<template>
    <div class="home">
        <b-container fluid>

            <HomeRecentRelatedSites />

            <b-row>
                <b-col cols="12" lg="4" xl="3" offset-xl="1">
                    <HomeCareerSelector/>
                </b-col>
                <b-col cols="12" lg="8" xl="7">
                    <HomeCoursesList/>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import HomeRecentRelatedSites from './HomeRecentRelatedSites'
import HomeCareerSelector from './HomeCareerSelector'
import HomeCoursesList from './HomeCoursesList'

export default {
    name: 'Home',
    components: {
        HomeRecentRelatedSites,
        HomeCareerSelector,
        HomeCoursesList
    }
}
</script>
